import { render, staticRenderFns } from "./setUp.vue?vue&type=template&id=48ed6e04&scoped=true"
import script from "./setUp.vue?vue&type=script&lang=js"
export * from "./setUp.vue?vue&type=script&lang=js"
import style0 from "./setUp.vue?vue&type=style&index=0&id=48ed6e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ed6e04",
  null
  
)

export default component.exports